import React, { useState } from 'react'
import { Modal } from 'react-bootstrap'

import './PlansSummaryModal.scss'

interface PlansSummaryModalProps {
  show: boolean
  onHide: () => void
}

type BillingCycle = 'annual' | 'monthly'

const plansUrl = 'https://accounts.pl4nner.com/plans'

const PlansSummaryModal = ({ show, onHide }: PlansSummaryModalProps) => {
  const [billingCycle, setBillingCycle] = useState<BillingCycle>('annual')
  const billingLabel = billingCycle === 'annual' ? 'facturacion anual' : 'facturacion mensual'

  const handleOpenPlans = () => {
    const plansWindow = window.open(plansUrl, '_blank', 'noopener,noreferrer')

    if (plansWindow) plansWindow.opener = null

    onHide()
  }

  const plans = [
    {
      name: 'Gratis',
      price: '$0',
      description: 'Gratis para siempre',
      note: 'Limitacion en el uso de la aplicacion',
      button: 'Empieza ahora',
      tone: 'muted',
      features: ['1 proyecto activo', 'Usuarios limitados', 'Soporte basico'],
    },
    {
      name: 'Experto',
      price: billingCycle === 'annual' ? '$5,50' : '$6,50',
      description: `usuario / mes - ${billingLabel}`,
      note: billingCycle === 'annual' ? 'Ahorra 15% con facturacion anual' : 'Pago mensual flexible',
      button: 'Empieza ahora',
      tone: 'success',
      features: ['4 proyectos activos', 'Equipos y tareas', 'Reportes esenciales'],
    },
    {
      name: 'Pro',
      price: billingCycle === 'annual' ? '$7,50' : '$9,50',
      description: `usuario / mes - ${billingLabel}`,
      note: billingCycle === 'annual' ? 'Ahorra 20% con facturacion anual' : 'Plan profesional mensual',
      button: 'Empieza ahora',
      tone: 'featured',
      badge: 'Popular',
      features: ['10 proyectos activos', 'Last Planner System', 'Indicadores avanzados'],
    },
    {
      name: 'Empresa',
      price: 'Contactenos',
      description: 'Plan a la medida de tu organizacion',
      note: 'Ahorra 25% con facturacion anual',
      button: 'Contactenos',
      tone: 'dark',
      features: ['Proyectos ilimitados', 'Acompanamiento', 'Configuracion avanzada'],
    },
  ]

  return (
    <Modal
      show={show}
      centered
      dialogClassName="pl4-plans-modal"
      onHide={onHide}
    >
      <Modal.Header closeButton className="pl4-plans-modal__header">
        <div className="pl4-plans-modal__brand">
          <span className="pl4-plans-modal__mark">
            <i className="far fa-gem" />
          </span>
          <div>
            <strong>PL4NNER</strong>
            <span>Planes</span>
          </div>
        </div>
      </Modal.Header>

      <Modal.Body className="pl4-plans-modal__body">
        <section className="pl4-plans-modal__hero">
          <span className="pl4-plans-modal__eyebrow">PLANES PL4NNER</span>
          <h2>
            Potencia tu proyecto con <strong>Last Planner System</strong> automatizado
          </h2>
          <p>
            Todas las funciones ilimitadas por 30 dias. No se necesita tarjeta de credito.
          </p>

          <div className="pl4-plans-modal__billing" role="tablist" aria-label="Frecuencia de facturacion">
            <button
              type="button"
              className={billingCycle === 'annual' ? 'is-active' : ''}
              onClick={() => setBillingCycle('annual')}
            >
              Anual - ahorra hasta 25%
            </button>
            <button
              type="button"
              className={billingCycle === 'monthly' ? 'is-active' : ''}
              onClick={() => setBillingCycle('monthly')}
            >
              Mensual
            </button>
          </div>
        </section>

        <section className="pl4-plans-modal__cards" aria-label="Resumen de planes">
          {plans.map((plan) => (
            <article
              className={`pl4-plan-card pl4-plan-card--${plan.tone}`}
              key={plan.name}
            >
              {plan.badge && <span className="pl4-plan-card__badge">{plan.badge}</span>}
              <div className="pl4-plan-card__content">
                <h3>{plan.name}</h3>
                <strong>{plan.price}</strong>
                <p>{plan.description}</p>
                <em>{plan.note}</em>
              </div>

              <button
                type="button"
                className="pl4-plan-card__action"
                onClick={handleOpenPlans}
              >
                {plan.button}
              </button>

              <ul>
                {plan.features.map((feature) => (
                  <li key={feature}>
                    <i className="fas fa-check" />
                    {feature}
                  </li>
                ))}
              </ul>
            </article>
          ))}
        </section>
      </Modal.Body>

      <Modal.Footer className="pl4-plans-modal__footer">
        <button type="button" className="pl4-btn pl4-btn-secondary" onClick={onHide}>
          Cerrar
        </button>
        <button type="button" className="pl4-btn pl4-btn-primary" onClick={handleOpenPlans}>
          Ver pagina de planes
        </button>
      </Modal.Footer>
    </Modal>
  )
}

export default PlansSummaryModal
